import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import Sidebar from '../../Navbar/Sidebar';
import { Outlet } from 'react-router-dom';
import TopNav from '../../Navbar/TopNav'; // Import TopNav
import { useGlobalContext } from '../../../Context/GlobalContext';

const Dashboard: React.FC = () => {
  const { userData } = useGlobalContext();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
      }}
    >
      <CssBaseline />
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        {/* Sidebar with fixed width */}
        {userData?.UserRole && (
          <Box sx={{ width: '5vw', position: 'relative', flexShrink: 0 }}>
            <Sidebar />
          </Box>
        )}

        {/* Main content takes the rest of the available width */}
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: userData?.UserRole ? '95vw' : '100vw', gap:'1.3vw'}}>
          {userData?.UserRole && <TopNav />}
          <Box
            sx={{
              overflowY: 'auto', // Ensures a scrollbar appears only when needed
              // '@media (max-width:600px)': {
              //   padding: 1, // Adjust padding for smaller screens
              //   pt: 0
              // },
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;